import { Icon } from "@iconify/vue";
import { createApp } from "vue";

import App from "./App.vue";
import { installVueErrorHandler, useErrorReporter } from "./composables/useErrorReporter";
import { useTheme } from "./composables/useTheme";
import { router } from "./router";

import "./styles.css";

useTheme();
useErrorReporter();

const app = createApp(App).component("Icon", Icon).use(router);
installVueErrorHandler(app);
app.mount("#app");
